<template>
  <div v-show="!isBulkSelect" :class="`comp-xl-association comp-xl-association${modulesItem?.setting?.id || basicData?.id}${randomString}`" v-if="modulesItem?.setting?.id || basicData?.id">
    <fh-select :options="list" :style="{ width: isAutoRequest ? 'calc(100% - 32px)' : '100%' }" :placeholder="modulesItem?.placeholder || ''" v-model="selectVal" :multiple="multiple" :disabled="disabled" @popup-visible-change="popupSelect" ref="fhSelectRef" @remove="changeHandle('')" :fallback-option="fallbackOption">
      <template #associationContent>
        <div class="xl-association-content-edit" :style="{ width: getWidth(), maxHeight: maxHeightStyle + 'px' }">
          <!-- 可编辑 -->
          <div class="search-content">
            <jw-input ref="searchInputRef" placeholder="搜索" allow-clear v-model="keyword" @input="changeKeyword" />
          </div>
          <div class="association-list-content">
            <div class="association-list">
              <jw-list @reach-bottom="dropdownSelect" :bordered="false" :split="false" :data="list" :loading="loading" :scrollbar="false" :max-height="maxHeightStyle - 40">
                <template #item="{ item }">
                  <jw-list-item :key="item.id">
                    <div class="association-item-content" @click="changeHandleList(item.id)">
                      <div class="association-item" :class="{ 'association-item-columns': columns?.length == 1 }">
                        <div :class="['matrix-association-main-field', columns?.length == 1 ? 'field-empty' : '']">
                          {{ item?.[outShowField || data.mainField] || associationEmptyText }}
                        </div>
                        <template v-for="(col, i) in columns" :key="i">
                          <div class="matrix-association-normal-field" v-if="!col?.outShowField">
                            {{ col.fieldName }}：
                            <xl-text-value :record="{ ...col, ...{ fieldValue: item[col.fieldKey] } }" />
                          </div>
                        </template>
                      </div>
                      <div class="association-redio-content">
                        <icon-check-circle-fill v-if="isSelected(item)" class="selected-icon" />
                      </div>
                    </div>
                  </jw-list-item>
                </template>
                <template #empty>
                  <xl-empty v-if="!loading && !list?.length" class="empty-text" :msg="$t('没有找到匹配的数据')"></xl-empty>
                  <div v-else :style="{ height: '150px' }"></div>
                </template>
              </jw-list>
            </div>
          </div>
        </div>
      </template>
    </fh-select>
    <jw-button class="association-btn" :disabled="disabled" @click="openDialog" v-if="isAutoRequest">
      <template #icon>
        <icon-plus />
      </template>
    </jw-button>
  </div>
  <!-- 弹窗打开 S -->
  <jw-modal v-model:visible="visible" width="70%" title-align="start" :ok-loading="modalLoading" :on-before-ok="handleOk" unmount-on-close :mask-closable="false">
    <template #title> {{ $t('选择关联') }}{{ objectName || $t('对象') }} </template>
    <jw-space direction="vertical" fill>
      <div class="operate-buttons">
        <div class="operate-buttons-conditions">
          <!-- 根据字段筛选 -->
          <field-filter :defaultValue="data.inputSearchDefaultValue" :fieldColumns="data.fieldFilterColumns" style="margin-left: 8px" @cb="fieldCondition"></field-filter>
          <!-- 高级筛选 -->
          <jw-trigger class="trigger-container" v-model:popup-visible="filterVisible" trigger="click" position="bl">
            <jw-button v-if="filterConditions?.children?.length" size="mini" shape="round" type="outline" @click="toggleVisible" class="filter-btn">
              <template #icon>
                <qf-icon-table-filtrate />
              </template>
              <jw-space>
                <span> {{ filterText }}</span>
                <icon-close class="hand" v-if="filterConditions?.children?.length > 0" @click="clearAllCondition(true)" />
              </jw-space>
            </jw-button>
            <jw-tooltip v-else :content="$t('高级筛选')">
              <span class="hand icon-bg-color" @click="toggleVisible">
                <qf-icon-table-filtrate />
              </span>
            </jw-tooltip>
            <template #content>
              <div class="custom-field-condition-public">
                <fh-custom-search-ultra :headerTitle="$t('条件配置')" ref="customFieldConditionRef" :entity="data.entity" :conditions="filterConditions?.children" :showDefaultCondition="true" :maxHeight="300" :width="600" :border="true" @clearAll="clearAllCondition" @submit="searchSubmit"> </fh-custom-search-ultra>
              </div>
            </template>
          </jw-trigger>
        </div>
        <jw-button type="text" v-if="userInfo?.roles?.indexOf(roleName) !== -1" @click="openLyForm">
          {{ buttonText?.[roleName] || $t('新建') }}
        </jw-button>
      </div>
      <fh-table v-on="tPropsEvent" v-bind="tProps" ref="fhTableRef" row-key="id" :max-height="400" resizable :scroll="{ y: 400 }" :columns="formatPopColumns" :selected-row-keys="ids" :uuid="modulesItem?.setting?.id" @select-change="xlTableSelect"> </fh-table>
      <div v-if="data.showColOverlay" class="overlay" @click.stop="showLay(false)"></div>
    </jw-space>
  </jw-modal>
  <!-- 弹窗打开 E -->
  <fh-add-edit ref="addEditRef" @cb="loadTList()" />
</template>

<script setup lang="jsx">
import { ref, reactive, inject, onMounted, watch, computed, nextTick, defineAsyncComponent, provide } from 'vue';

const lyAvatar = defineAsyncComponent(() => import('@/components/layout/ly-avatar/ly-avatar.vue'));
const xlStatus = defineAsyncComponent(() => import('@/components/xl-status/xl-status.vue'));
const lyAttachmentList = defineAsyncComponent(() => import('@/components/layout/ly-attachment-list/ly-attachment-list.vue'));
const lyAssociation = defineAsyncComponent(() => import('@/components/layout/ly-association/ly-association.vue'));
const associationNonEditAble = defineAsyncComponent(() => import('@/components/unit/association-non-edit-able/association-non-edit-able.vue'));
const lyComputedCmp = defineAsyncComponent(() => import('@/components/unit/computed-cmp/computed-cmp.vue'));
const lyRichText = defineAsyncComponent(() => import('@/components/layout/ly-rich-text/ly-rich-text.vue'));
const lyTagFields = defineAsyncComponent(() => import('@/components/layout/ly-tag-fields/ly-tag-fields.vue'));
import { Message } from '@arco-design/web-vue';
import { publicService, setService } from '@/api/';
import { tools } from '@/utils/tools';
import useFhTable from '@/hooks/fh-table';
import { yunminOrgId, cyzqOrgId, associationEmptyText } from '@/utils/const';
import { watchEffect } from 'vue';
import { cloneDeep } from 'lodash';
import useFhForm from '@/hooks/fh-form';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import xlTextValue from '@/components/xl-text-value/xl-text-value.vue';
import { useUserStore } from '@/store';
const { userInfo } = useUserStore();
import useEditFields from '@/hooks/edit-field';
const { setEditFieldVal } = useEditFields();
const searchInputRef = ref(null);
const { getSendData } = useFhForm();
// 弹窗表格
const { tProps, setTProps, tPropsEvent, setLoadListParams, loadTList } = useFhTable(publicService.getAssociationRadio.bind(publicService));

const data = reactive({
  entity: '',
  entityList: [3, 6, 8, 10, 13],
  specialProduct: [7, 9, 11, 14, 32],
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //第一个
    objList: {}, //fieldKey：obj 类型
    filterType: {}, //中间
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
  },
  showColOverlay: false, // 父组件弹窗状态
  colOverlayId: undefined, // 哪列弹窗
  fieldFilterColumns: [], //筛选字段
  inputSearchCondition: null,
  inputSearchDefaultValue: '',
  fieldsSort: []
});
const filterConditions = ref({ value: null, children: [] });

const outShowField = computed(() => props.modulesItem?.setting?.outShowField || mainField.value);

const customFieldConditionRef = ref();
const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };
const randomString = tools.randomString(10);
const props = defineProps({
  type: {
    //布局类型 30：关联表格 20：字段
    type: [String, Number],
    default: ''
  },
  multiple: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean
  },
  modelValue: {
    type: [String, Number, Array]
  },
  customerId: {
    type: [String, Number]
  },
  selectedItem: {
    type: [Object, Array]
  },
  placeholder: {
    type: String,
    default: ''
  },
  modulesItem: {
    type: Object,
    require: true,
    default: () => {
      return {};
    }
  },
  formData: {
    type: Object,
    required: true
  },
  basicData: {
    type: Object,
    default: () => {
      return {};
    }
  },
  popupContainer: {
    //挂载节点 兼容某些特殊情况下拉被遮盖
    type: String,
    default: ''
  },
  singleFieldEdit: {
    type: Boolean,
    default: false
  },
  /**
   * 是否批量选择
   * 字段影响：当值为true时，下拉选择隐藏不显示，弹窗点击确定后不关闭，由外部调用抛出方法进行关闭
   */
  isBulkSelect: {
    type: Boolean,
    default: false
  },
  //批量新增补充主表单数据
  supplementData: {
    type: Object,
    default: () => {
      return {};
    }
  },
  tableId: {
    type: [String, Number],
    default: ''
  }
});
const emits = defineEmits(['update:modelValue', 'update:selectedItem', 'change']);
const entityType = computed(() => {
  return props.modulesItem?.followEntity ? props.modulesItem?.followEntity : props.modulesItem?.setting?.fieldExt || props.basicData?.relation;
});
const mainField = ref('name');
const selectVal = ref(props.multiple ? [] : '');
const maxHeightStyle = ref(370);

const fhSelectRef = ref();

const isNeedRequest = ref(true);
const totalPage = ref(0);
const page = ref(1);

const filterText = computed(() => {
  return filterConditions.value?.children?.length ? `${t('筛选')}+${filterConditions.value.children.length}` : t('筛选');
});

const getWidth = () => {
  return fhSelectRef.value?.getWidth();
};

//是否自动调用接口 yunmin和创易智企的特定字段只能搜索，不自动调用接口
const isAutoRequest = computed(() => {
  let _isAuto = true;
  if (userInfo?.orgId == yunminOrgId && props.modulesItem?.setting?.fieldKey == 'association_MZxdw7') {
    _isAuto = false;
  }
  if (userInfo?.orgId == cyzqOrgId && props.modulesItem?.setting?.fieldKey == 'association_5nHzQE') {
    _isAuto = false;
  }
  return _isAuto;
});
const popupSelect = async (visible) => {
  if (visible && isNeedRequest.value) {
    page.value = 1;
    await getAssociationRadioFields();
    if (isAutoRequest.value) {
      await getAssociationRadio();
    }
  }
  nextTick(() => {
    if (searchInputRef.value) {
      searchInputRef.value?.focus();
    }
  });
};
// 输入框搜索
const fieldCondition = (v) => {
  if (v?.params) {
    data.inputSearchDefaultValue = v?.params?.value;
    data.inputSearchCondition = v?.params;
  } else {
    data.inputSearchCondition = null;
    data.inputSearchDefaultValue = '';
  }
  getAssociationList();
};

watch(
  () => props.formData,
  async () => {
    isNeedRequest.value = true;
  },
  { deep: true }
);
watch(
  () => props.modulesItem?.followEntity,
  async () => {
    if (props.modulesItem?.followEntity) {
      data.entity = props.modulesItem?.followEntity;
      nextTick(() => {
        getAddRule();
        buttonText.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, data.entity);
      });
      await getObjectName();
      await getAssociationRadioFields();
      await getAssociationRadio();
    }
  }
);
const list = ref([]);
const columns = ref([]);
const popColumns = ref([]);
const formatPopColumns = ref([]);
const loading = ref(false);
const keyword = ref(null);

const fallbackOption = (v) => {
  let _label = (props.multiple && props.modulesItem?.customValue?.length > 0 ? props.modulesItem?.customValue?.map((v) => v?.label || associationEmptyText) : props.modulesItem?.customValue?.label) || selectOption.value || props.modulesItem?.fieldValueName || props.basicData?.fieldValueName || associationEmptyText || v;
  if (props.multiple && Array.isArray(props.modulesItem?.fieldValue)) {
    const _pos = props.modulesItem?.fieldValue.indexOf(v);
    if (_pos > -1) {
      _label = _label[_pos];
    }
  }
  return { label: _label, value: v };
};

//是否选中
const isSelected = (item) => {
  return (Array.isArray(selectVal.value) && selectVal.value?.find((itemVal) => itemVal == item.id)) || item.id == selectVal.value;
};

const changeKeyword = tools.debounceFn(
  (v) => {
    page.value = 1;
    //定开为空不做操作
    list.value = [];
    if (v != '' || isAutoRequest.value) {
      getAssociationRadio(false);
    }
  },
  300,
  false
);

const getAssociationRadioFields = async (isPop = false) => {
  try {
    loading.value = true;
    const params = {
      pop: isPop,
      apiIndex: Math.random()
    };
    if (props.basicData?.id) {
      params['id'] = props.basicData?.id;
      params['entity'] = props.basicData?.entity;
      params['fieldKey'] = props.basicData?.fieldKey;
    } else {
      params['settingId'] = props.modulesItem?.setting?.id;
      if (props.modulesItem?.followEntity) {
        params['entity'] = props.modulesItem?.followEntity;
      }
    }
    const res = await publicService.getAssociationRadioFields(params);
    if (!res.error) {
      mainField.value = res.result.filter((v) => v?.mainField)?.[0]?.fieldKey;
      if (isPop) {
        //2025年12月29日15:31:52 客户可能在弹窗不配置主属性字段，所以在这里后端默认追加了主属性字段，需要过滤掉
        popColumns.value = res.result?.filter((v) => v?.showMainField);
        // const filterTypes = [1, 0, 26, 11, 13, 12, 25, 27];
        // 先按fieldType过滤
        // 对类型为27的元素的settings数组进行过滤，只保留fieldType存在于filterTypes中的元素
        // 先基础过滤

        data.fieldFilterColumns = JSON.parse(JSON.stringify(popColumns.value));

        data.fieldFilterColumns.forEach((item) => {
          if (item.settings) {
            // 支持筛选tree组件
            item.fieldVos = item.settings;
            delete item.settings;
          }
        });
      } else {
        columns.value = res.result;
        columns.value = columns.value?.map((v) => {
          return {
            ...v,
            outShowField: v?.fieldKey == outShowField.value ? outShowField.value : ''
          };
        });
      }
    }
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};
const apiSwitch = ref(false);
const dropdownSelect = () => {
  if (!apiSwitch.value && totalPage.value > page.value) {
    page.value++;
    nextTick(() => {
      getAssociationRadio();
    });
  }
};

const getAssociationRadio = async (isPop = false) => {
  isNeedRequest.value = false;
  loading.value = true;
  apiSwitch.value = true;
  // try {
  const params = {};
  if (!isPop) {
    if (props.basicData?.id) {
      params['id'] = props.basicData?.id;
      params['entity'] = props.basicData?.entity;
      params['fieldKey'] = props.basicData?.fieldKey;
    } else {
      params['settingId'] = props.modulesItem?.setting?.id;
      params['dataRangeConditions'] = props.modulesItem?.associationDataRangeConditions ?? null;
      params['data'] = { ...getSendData(props.formData), ...props.supplementData };
      if (props.modulesItem?.followEntity) {
        params['entity'] = props.modulesItem?.followEntity;
      }
      if (props.tableId) {
        //如果是批量，则追加表格id用于后端查询数据范围
        params['tableId'] = props.tableId;
      }
      //兼容行内编辑时查找关联条件不生效，需要根据当前数据id去匹配对应条件
      if (props.modulesItem?.lineEditParams?.entity && props.modulesItem?.lineEditParams?.businessId) {
        params['entity'] = props.modulesItem?.lineEditParams?.entity;
        params['id'] = props.modulesItem?.lineEditParams?.businessId;
      }
    }

    params['pop'] = isPop;
    params['page'] = page.value;
    params['pageSize'] = 10;
    params['keyWord'] = keyword.value || '';
  }
  const res = await publicService.getAssociationRadio(params);
  if (!res.error) {
    const _data = res.result.records;
    _data.map((v) => {
      v['value'] = v?.id;
      v['label'] = v?.[outShowField.value] || associationEmptyText;
    });
    totalPage.value = res.result?.pages;
    if (page.value == 1) {
      list.value = _data;
    } else {
      list.value = [...list.value].concat(_data);
    }
  }
  loading.value = false;
  apiSwitch.value = false;
};
const selectOption = ref(null);

// select事件
const _customValue = ref([]);
const copyList = ref([]);

const changeHandleList = (v) => {
  if (props.multiple) {
    const findIndex = selectVal.value?.findIndex((el) => el == v);
    if (findIndex > -1) selectVal.value?.splice(findIndex, 1);
    if (findIndex == -1) {
      selectVal.value.push(v);
    }
    changeHandle(selectVal.value);
  } else {
    changeHandle(v);
  }
};
const changeHandle = (v) => {
  keyword.value = '';
  emits('update:modelValue', props.multiple ? selectVal.value?.filter((v) => v !== '') : v);
  const _list = [];
  if (props.multiple && selectVal.value?.length > 0) {
    const _tmp = [];
    list.value.map((v) => {
      _tmp.push(v?.value);
    });
    selectVal.value.map((v) => {
      const _sourceData = props.modulesItem?.customValue?.length ? JSON.parse(JSON.stringify(props.modulesItem?.customValue)) : _customValue.value?.length ? _customValue.value : [];
      if (_tmp.indexOf(v) < 0 && _sourceData?.length > 0) {
        _sourceData.map((cv) => {
          if (cv.value == v) {
            _list.push(cv);
          }
        });
      }
    });
  }
  let item = [...list.value, ..._list].filter((el) => (props.multiple ? v.indexOf(el.value) > -1 : v === el.value));
  item = item.map((el) => {
    el[`_name`] = el.label;
    return el;
  });
  _customValue.value = item;
  copyList.value = _list;
  if (!props.multiple) fhSelectRef.value?.popupVisibleChangeFn();

  emits('change', v, item);
  emits('update:selectedItem', props.multiple ? item : item?.[0]);
};
const flowStage = inject('flow-stage')?.isTask;

watch(
  () => selectVal.value,
  (vv, o) => {
    //type 20主表单 30关联表格 30不需要emit
    if ((o.length === vv.length && o.toString() === vv.toString()) || o == vv || flowStage || props.isBulkSelect) {
      return;
    }

    if (props.type != 30 && props.type != 35) {
      let customList = [];
      if (props.modulesItem?.customValue) {
        customList = Array.isArray(props.modulesItem?.customValue) ? [...props.modulesItem.customValue] : [props.modulesItem?.customValue];
      }

      const item = [...list.value, ...copyList.value, ...customList].filter((el) => {
        if (Array.isArray(vv)) {
          return vv.includes(el.value);
        } else {
          return vv === el.value;
        }
      });

      emits('change', selectVal.value, item);
    }
  },
  { deep: true }
);

// 弹窗
const visible = ref(false);
const modalLoading = ref(false);
const tableLoading = ref(false);
const setRender = (h, params) => {
  const setEntity = params.entity;
  let setFieldValue = params.fieldValue;
  const editParams = {
    fieldInfo: params?.fieldInfo,
    loading: data.loading,
    fieldValue: setFieldValue,
    originalValue: params.fieldValue, //原值
    fieldExt: params.fieldExt,
    fieldType: params.fieldType,
    fieldKey: params.fieldKey,
    fieldName: params.fieldName,
    mainField: params.mainField,
    businessId: params.record['id'] //这条数据的id
  };

  // 创建对象映射不可编辑组件
  const moreComponentMap = {
    4: xlStatus,
    6: lyAvatar,
    12: lyAssociation,
    18: lyAttachmentList,
    25: associationNonEditAble,
    26: lyRichText
  };
  const nSelectComponent = moreComponentMap[params.fieldType];
  if ((params.fieldValue || params.fieldValue === 0) && params.fieldValue !== '') {
    setFieldValue = setEditFieldVal(params.fieldType, params.fieldValue, params.fieldExt); //处理可编辑字段的值
    if (setEntity === 4 && params.fieldType === 4 && params.fieldKey === 'taxRate') {
      //产品对象的税率特殊处理
      return tools.getPercentage(params.fieldValue, 0) + '%' || '';
    } else if (params.fieldType === 4 && params.fieldKey === 'status') {
      //生命状态
      return h(nSelectComponent, {
        status: params.fieldValue, //生命状态
        statusOrigin: params.record['statusOrigin'], //生命状态
        rollbackRoot: params.record['rollbackRoot'] // 退回状态
      });
    } else if (params.fieldType === 6) {
      return h(nSelectComponent, {
        record: params.fieldValue
      });
    } else if (params.fieldType === 11) {
      //超链接
      return h(
        'a',
        {
          style: {
            color: 'rgb(var(--link-6))',
            cursor: 'pointer'
          },
          href: params.fieldValue,
          target: '_blank'
        },
        t('查看')
      );
    } else if (params.fieldType === 18) {
      //附件
      return h(lyAttachmentList, {
        fieldValue: params.fieldValue
      });
    } else if (params.fieldType === 12) {
      //查找关联单选
      return h(lyAssociation, {
        isList: true,
        value: params.fieldValue,
        entity: params.fieldExt,
        listEntity: setEntity
      });
    } else if (params.fieldType === 25) {
      //查找关联
      return h(associationNonEditAble, { editParams });
    } else if (params.fieldType === 24) {
      //计算类型
      return h(lyComputedCmp, { params });
    } else if (params.fieldType === 26) {
      return h(lyRichText, {
        fieldValue: params.fieldValue
      });
    } else {
      if (params.fieldType === 23 && !isNaN(parseFloat(setFieldValue))) return setFieldValue + '%';
      if (params.fieldType === 7 && !isNaN(parseFloat(setFieldValue))) {
        const getFieldExt = tools.isJSON(params.fieldExt) && JSON.parse(params.fieldExt);
        return setFieldValue + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
      }
      if ([2, 3, 4, 5, 10].includes(params.fieldType)) {
        return h(lyTagFields, {
          isList: true,
          fieldValue: setFieldValue,
          styleInfo: params.fieldExt,
          fieldType: params.fieldType,
          fieldKey: params.fieldKey,
          fieldName: params.fieldName
        });
      }
      return params.fieldValue?.label ?? params.fieldValue?.value ?? setFieldValue ?? '-';
    }
  } else {
    return params.fieldValue == '' ? '-' : params.fieldValue?.label ?? params.fieldValue?.value ?? params.fieldValue ?? '-';
  }
};
const getSubFormField = (fieldVos) => {
  return fieldVos?.map((v) => {
    return {
      fieldKey: v.fieldKey,
      entityId: v.entityId,
      id: v.id,
      fieldType: v.fieldType
    };
  });
};

// 追加排序字段
const addFieldsSort = (fieldList, fieldsSort) => {
  if (fieldList?.length && fieldsSort?.length) {
    fieldList?.forEach((item) => {
      const obj = fieldsSort?.find((e) => {
        return e.fieldKey == item.fieldKey;
      });
      if (obj) {
        if (obj.sort === true || obj.sort === false) {
          item.fieldSort = obj.sort;
        } else {
          item.fieldSort = '';
        }
      } else {
        item.fieldSort = '';
      }
    });
  }
  // 当没有排序字段时  清空 fieldList 里的 fieldSort
  if (fieldsSort?.length == 0) {
    popColumns.value?.forEach((item) => (item.fieldSort = ''));
  }
};
const sortChange = (v) => {
  const foundItem = data.fieldsSort.find((ele) => ele.fieldKey === v.fieldKey);
  if (foundItem) {
    // 如果相同则取消排序
    if (foundItem.sort === v.sort) {
      data.fieldsSort = data.fieldsSort.filter((ele) => ele.fieldKey != v.fieldKey);
    } else {
      // 如果不相同 找到匹配项，合并属性
      Object.assign(foundItem, v);
    }
  } else {
    // 如果没有找到，添加新项
    data.fieldsSort.push(v);
  }
  addFieldsSort(popColumns.value, data.fieldsSort);
  getAssociationList();
};

const getSearchData = (v) => {
  data.ruleForm.conditions = v?.conditions || [];
  filterConditions.value.children = v?.conditions;
  getAssociationList();
};

const getConditions = async () => {
  const res = await setService.getEntitySettings({ entity: entityType.value, apiIndex: Math.random() }); //查询entity所有字段
  data.ruleForm.leadsFieldList = res.result;
  data.ruleForm.leadsFieldList
    ?.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18))
    ?.forEach((item) => {
      if (item.fieldType === 10) {
        item.fieldExt = item.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      } else if (item?.business?.fieldType == 10) {
        item.business.fieldExt = item.business?.fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
      }
      data.ruleForm.objList[item.fieldKey] = item;
    });
  try {
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    if (!json.error) {
      json.result?.forEach((item) => {
        if (item.fieldType === 24) {
          data.ruleForm.filterType[item.fieldType] = item.computeMaps; //第二个框
        } else {
          data.ruleForm.filterType[item.fieldType] = item.conditions; //第二个框
        }
      });
    }
  } catch (e) {
    console.log(e);
  }
};

// 遮罩层
const showLay = (val, key) => {
  data.showColOverlay = val;
  if (!key) return;
  data.colOverlayId = key;
};

// 创建列配置
const createColumnConfig = (item) => {
  const k = item.fieldKey; //字段标识
  const freeze = item.freeze; //是否为固定行
  const fieldType = item.fieldType == 21 ? item?.business?.fieldType : item?.fieldType;
  const fieldExt = item.fieldType == 21 ? item?.business?.fieldExt : item?.fieldExt;
  const width = item.mainField ? 250 : tools.getStrLen(item.fieldName) <= 6 ? 120 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 20;
  // 表格的className属性设置单元格的类名
  const colType = {
    title: (h, { col }) => (item.fieldType == 27 ? item.fieldName : <ly-col-more col={col} record={item} fieldName={item.fieldName} ruleForm={data.ruleForm} findAssociation={findAssociation} showColOverlay={data.showColOverlay} colOverlayId={data.colOverlayId} showLayCb={showLay} sortCb={sortChange} isAssociation={true} hasFrozen={false} getSearchDataCb={getSearchData} isSubForm={false} />),
    colKey: k,
    type: item.type,
    ellipsisTitle: { theme: 'light' },
    ellipsis: [3, 5, 12, 25].includes(fieldType) || (item.type == 0 && fieldType == 5) ? undefined : { theme: 'default' },
    id: item.id,
    stopPropagation: [12, 25].includes(fieldType) ? true : false,
    fieldName: item.fieldName,
    fieldType: fieldType,
    oldFieldType: item?.fieldType,
    fieldExt: fieldExt,
    resize: tools.getStrLen(item.fieldName) <= 5 ? { minWidth: 120 } : tools.getStrLen(item.fieldName) > 10 ? { minWidth: 300 } : { minWidth: tools.getStrLen(item.fieldName) * 30 },
    className: item.fieldType == 27 ? 'sub-form-table-border' : '',
    fixed: freeze ? 'left' : undefined
  };
  // 表格的cell函数
  const render = (h, { row }) => {
    const record = JSON.parse(JSON.stringify(row));
    const params = {
      ...item,
      fieldValue: record[k],
      fieldType: fieldType,
      oldFieldType: item?.fieldType,
      fieldExt: fieldExt,
      record: record,
      fieldInfo: item //兼容查找关联编辑，需要拼接字段的modules结构
    };
    return setRender(h, params);
  };
  colType.width = width;
  colType.cell = render;
  return colType;
};
// 创建子表单列配置
const createChildColumns = (item) => {
  const colTypeChildren = [];
  item?.settings?.forEach((el, index) => {
    const childRender = (h, { row }) => {
      const record = JSON.parse(JSON.stringify(row));
      const subFormData = record?.[item?.fieldKey] || [];
      // 遍历子表单数据，为每个子表单记录渲染单元格
      if (subFormData?.length > 0) {
        return h('p', { class: 'child-table-container' }, [
          ...subFormData.map((subFormRecord) => {
            const params = {
              ...el,
              fieldValue: subFormRecord?.[el.fieldKey] || '', // 使用子表单中的数据
              record: subFormRecord, // 使用子表单中的数据
              fieldInfo: { ...el, setting: { ...el } }, //兼容查找关联编辑，需要拼接字段的modules结构
              computedInfo: record?.computedInfo ? record?.computedInfo : null
            };
            return h('p', { class: 'child-table-container-second' }, setRender(h, params, true));
          })
        ]);
      } else {
        return h('p', { class: 'child-table-temp-container' }, '-');
      }
    };

    const getColType = {
      title: (h, { col }) => <ly-col-more col={col} fieldName={el.fieldName} findAssociation={findAssociation} ruleForm={data.ruleForm} colOverlayId={data.colOverlayId} showColOverlay={data.showColOverlay} getSearchDataCb={getSearchData} sortCb={sortChange} isAssociation={true} showLayCb={showLay} setting={item} isSubForm={true} />,
      colKey: `${item.fieldKey}.${el.fieldKey}`,
      type: el.type,
      ellipsisTitle: { theme: 'light' },
      ellipsis: { theme: 'default' },
      id: el.id,
      stopPropagation: [12, 25].includes(el.fieldType) ? true : false,
      fieldName: el.fieldName,
      fieldType: el.fieldType,
      setting: item?.settings?.length ? getSubFormField(item.settings) : null,
      fieldExt: el.fieldExt,
      width: tools.getStrLen(item.fieldName) <= 6 ? 180 : tools.getStrLen(item.fieldName) > 10 ? 220 : tools.getStrLen(item.fieldName) * 23,
      cell: childRender,
      className: item?.settings?.length == 1 ? 'sub-form-table-list sub-form-table-border-left sub-form-table-border-right' : index == 0 ? 'sub-form-table-list sub-form-table-border-left' : index == item?.settings?.length - 1 ? 'sub-form-table-list sub-form-table-border-right' : 'sub-form-table-list'
    };
    colTypeChildren.push(getColType);
  });
  return colTypeChildren;
};
// 创建选择行的列配置
const createRowSelectColumn = () => ({ colType: false, colKey: 'row-select', fixed: 'left', type: props.multiple ? 'multiple' : 'single', width: 46, resizable: false });
// 表格表头数据字段
const getColumns = (fields) => {
  const fieldList = fields?.filter((i) => ['parentCustomerId', 'calendarId', 'callId', 'recordId'].indexOf(i.fieldKey) === -1);
  console.log(116, fieldList);
  const colArray = [];
  fieldList?.forEach((item) => {
    const colConfig = createColumnConfig(item);
    if (item?.fieldType == 27) {
      //子表单
      const childCols = createChildColumns(item);
      colConfig.children = childCols;
    }
    colArray.push(colConfig);
  });
  // 单选多选
  colArray.unshift(createRowSelectColumn());
  return colArray;
};
const pagination = {
  current: 1,
  pageSize: props.isBulkSelect ? 50 : 10, //批量默认50条每页
  total: 0,
  showPageSize: true, // 是否显示数据条数选择器
  showJumper: true,
  pageSizeOptions: [10, 20, 30, 40, 50],
  size: 'small',
  isSaveLocal: true, // 是否保存本地分页大小
  totalContent: true // 是否显示数据总数
};
setTProps({
  pagination: { ...pagination }
});

const ids = ref([]);

const openDialog = async () => {
  data.inputSearchCondition = null;
  // 动态记录特殊处理
  if (props.modulesItem.value == 'businessId' && !props.modulesItem.followEntity) return;
  if (props.disabled) return;
  filterVisible.value = false;
  //如果没有名称 异步获取不影响主流程
  if (!objectName.value) {
    getObjectName();
  }
  try {
    ids.value = props.modelValue ? (Array.isArray(props.modelValue) ? props.modelValue : [props.modelValue]) : [];
    tableLoading.value = true;
    await getAssociationRadioFields(true);
    tableLoading.value = false;
    visible.value = true;
    formatPopColumns.value = getColumns(popColumns.value);
    const params = {
      pop: true
    };
    if (props.basicData?.id) {
      params['id'] = props.basicData?.id;
      params['entity'] = props.basicData?.entity;
      params['fieldKey'] = props.basicData?.fieldKey;
    } else {
      params['settingId'] = props.modulesItem?.setting?.id;
      if (props.tableId) {
        //如果是批量，则追加表格id用于后端查询数据范围
        params['tableId'] = props.tableId;
      }
      params['dataRangeConditions'] = props.modulesItem?.associationDataRangeConditions ?? null;
      params['data'] = { ...getSendData(props.formData), ...props.supplementData };
      if (props.modulesItem?.followEntity) {
        params['entity'] = props.modulesItem?.followEntity;
      }
    }
    setLoadListParams({});
    setLoadListParams(params);
    await loadTList(1);
    getConditions();
  } catch (e) {
    console.log(e);
    tableLoading.value = false;
    visible.value = false;
  }
};

//跨页选择相关数据
const selectedIds = ref([]);
const selectedData = ref([]);
// 表格选择
const xlTableSelect = (v) => {
  selectedData.value = selectedData.value.concat(tProps.value.data.filter((vd) => v?.includes(vd?.id) && !selectedIds.value?.includes(vd?.id)));
  selectedIds.value = Array.from(new Set(selectedIds.value.concat(v)));
  ids.value = v;
};
// 弹窗确定
const handleOk = async () => {
  //批量操作不做必选校验
  if (!ids.value?.length && !props.isBulkSelect) {
    Message.warning('至少选择一项数据');
    return false;
  }
  //当前列表数据
  if (!props.isBulkSelect) {
    let item = selectedData.value.filter((el) => ids.value.indexOf(el.id) > -1);
    selectVal.value = props.multiple ? ids.value : ids.value?.[0];
    item = item.map((el) => {
      el[`_name`] = el[mainField.value];
      el['value'] = el?.id;
      el['label'] = el[mainField.value];
      selectOption.value = el[mainField.value];
      return el;
    });
    //兼容行内编辑反显多选查找关联
    emits('update:modelValue', selectVal.value);

    emits('change', selectVal.value, item);
    emits('update:selectedItem', props.multiple ? item : item?.[0]);
  } else {
    //批量新增逻辑，将selectItem
    const _ids = cloneDeep(ids.value);
    const _oldIds = [];
    const _bulkData = [];
    modalLoading.value = true;
    if (_ids?.length) {
      props.selectedItem.forEach((si) => {
        if (_ids.includes(si.id)) {
          _bulkData.push(si);
          _oldIds.push(si.id);
        }
      });
      selectedData.value.forEach((tvd) => {
        if (_ids.includes(tvd.id) && !_oldIds.includes(tvd.id)) {
          _bulkData.push({
            id: tvd.id,
            label: tvd[mainField.value],
            value: tvd.id
          });
        }
      });
    }

    emits('change', {
      list: _bulkData,
      ids: _ids
    });
    return false; //阻止弹窗关闭
  }
};

// 加载
const buttonText = ref({});
onMounted(async () => {
  if (props.basicData?.id) {
    data.entity = Number(props.basicData?.relation);
  } else if (props.modulesItem?.followEntity) {
    data.entity = props.modulesItem?.followEntity;
  } else {
    data.entity = Number(props.modulesItem?.setting?.fieldExt);
  }
  nextTick(() => {
    getAddRule();
    buttonText.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, data.entity);
  });
});
const addEditRef = ref();
const openLyForm = () => {
  const params = { id: '', type: 30, viewId: -1, entity: data?.entity, copy: 0 };
  addEditRef.value?.open(params);
};
const roleName = ref('');
const getAddRule = () => {
  let _roleName = '';
  if (data?.entity == '1') {
    _roleName = 'clue';
  } else if (data?.entity == '101') {
    _roleName = 'cluePool';
  } else if (data?.entity == '2') {
    _roleName = 'customer';
  } else if (data?.entity == '3') {
    _roleName = 'businessOpportunity';
  } else if (data?.entity == '4') {
    _roleName = 'product';
  } else if (data?.entity == '6') {
    _roleName = 'priceSheet';
  } else if (data?.entity == '8') {
    _roleName = 'contract';
  } else if (data?.entity == '10') {
    _roleName = 'saleOrder';
  } else if (data?.entity == '12') {
    _roleName = 'afterSale';
  } else if (data?.entity == '13') {
    _roleName = 'returnOrder';
  } else if (data?.entity == '16') {
    _roleName = 'dynamicRecord';
  } else if (data?.entity >= '200') {
    //内置路由
    _roleName = data?.entity;
  }

  roleName.value = `${_roleName}:add`;
};
const objectName = ref('');
const getObjectName = async () => {
  try {
    if (!entityType.value) return false;
    const res = await setService.getSysObjEnumList({ entityType: entityType.value });
    if (!res.error) {
      objectName.value = res.result?.entityName;
    }
  } catch (e) {
    console.log(e);
  }
};

watchEffect(() => {
  if (props.multiple) {
    selectVal.value = Array.isArray(props.modelValue) ? props.modelValue?.filter((el) => el !== '') : [];
  } else {
    selectVal.value = isNaN(Number(props.modelValue)) ? '' : Number(props.modelValue);
  }
});
/******** 搜索开始 **********/

const filterVisible = ref(false);
const toggleVisible = () => {
  filterVisible.value = !filterVisible.value;
};

//清空所有
const clearAllCondition = (isGetList = false) => {
  filterConditions.value = {};
  filterConditions.value.children = [];
  data.ruleForm.conditions = [];
  if (isGetList === true) {
    getAssociationList();
  }
};

const searchSubmit = async () => {
  const resultConditions = await customFieldConditionRef.value.getAllConditions(false);
  if (!resultConditions) return;
  filterConditions.value.children = resultConditions;
  data.ruleForm.conditions = resultConditions || [];
  await getAssociationList();
  toggleVisible();
};

const getAssociationList = async () => {
  const params = {
    pop: true,
    conditions: {
      id: null,
      operation: 'or',
      isGroup: true,
      field: null,
      value: null,
      parentId: undefined,
      children: JSON.parse(JSON.stringify(filterConditions.value.children || []))
    },
    searchFields: data.inputSearchCondition ? data.inputSearchCondition : null
  };
  // 排序
  if (data.fieldsSort?.length) {
    params['sortSettings'] = data.fieldsSort;
  } else {
    params['sortSettings'] = undefined;
  }
  if (props.basicData?.id) {
    params['id'] = props.basicData?.id;
    params['entity'] = props.basicData?.entity;
    params['fieldKey'] = props.basicData?.fieldKey;
  } else {
    params['settingId'] = props.modulesItem?.setting?.id;
    params['dataRangeConditions'] = props.modulesItem?.associationDataRangeConditions ?? null;
    params['data'] = { ...getSendData(props.formData), ...props.supplementData };
  }
  setLoadListParams(params);
  await loadTList(1);
};

provide('defaultParams', {
  columns: computed(() => formatPopColumns.value)
});
/******** 搜索结束 **********/
const closeModal = () => {
  visible.value = false;
  modalLoading.value = false;
};
defineExpose({ openDialog, closeModal });
</script>
<style scoped lang="less">
@import './xl-association.less';
</style>
